import { ECouponType } from '@web/core/models';
import { SuperModel } from './super-model.model';

export class UserCouponThreshold extends SuperModel {
  cid: string;
  couponType: ECouponType;
  threshold: number;
  alreadyBurned: boolean;
  cashierUpn: string;
  spentOn: Date;
  eventCode: string;

  constructor(data: Partial<UserCouponThreshold> = {}) {
    super(data);
    this.couponType = data.couponType as ECouponType;
  }

  get canRequestCoupon(): boolean {
    return this.threshold > 0;
  }

  get serialised() {
    return {
      id: this.id,
      cid: this.cid,
      couponType: this.couponType,
      threshold: this.threshold,
      alreadyBurned: this.alreadyBurned,
      cashierUpn: this.cashierUpn,
      spentOn: this.spentOn,
      eventCode: this.eventCode,
    };
  }
}
